import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Form, Input, Button } from "antd";
import "./GSACreate.scss";
import backArrow from "../../../Assets/Images/back-arrow.svg";
import { userServices } from "../../../Services/API/userServices";
import { toast } from "react-toastify";
import { validatePhoneNumber } from "../../../Utils/phoneNumberValidation";

export default function GSACreate() {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  const action = location?.state?.action;
  const state = location?.state?.data;

  const onSaveClick = async (values) => {
    try {
      const payload = {
        email: values?.emailId,
        phoneNo: `${values?.phoneNumber}`,
        userType: "GSA",
        firstName: values?.firstName || '',
        lastName: values?.lastName || '',
        location: values?.location || '',
        ...(action === "edit" && { uid: state?.uid }),
      };
      const response =
        action === "edit"
          ? await userServices?.updateUser(payload)
          : await userServices.createUser(payload);
      if (response?.data) {
        toast.success(
          action === "edit"
            ? "GSA user edited successfully"
            : "GSA user created successfully"
        );
        navigate("/");
      }
    } catch (error) {
      console.log("erro", error);
      toast.error( `${error?.response?.data?.message ||error?.response?.data || 'Sorry something went wrong'}`);
    }
  };

  return (
    <div className="form-page">
      <div className="forms-header-component">
        <div className="back-btn-container">
          <img
            src={backArrow}
            className="back-arrow"
            onClick={() => navigate("/")}
            alt="Back to GSA"
          />
        </div>
        <div className="heading-container">
          {action === "add"
            ? "Add New GSA"
            : `Edit - GSA - ${state?.firstName}`}
        </div>
      </div>
      <div className="fundraiser-form-component">
        <div className="form-container">
          <Form
            initialValues={{
              firstName: state?.firstName,
              lastName: state?.lastName,
              phoneNumber: state?.phoneNo?.slice(2),
              emailId: state?.email,
              location: state?.location,
            }}
            form={form}
            className="form-component"
            labelCol={{
              span: 8,
            }}
            colon={false}
            onFinish={onSaveClick}
          >
            <Form.Item
              className="form-item"
              label={<div className="form-label">First Name:</div>}
              name="firstName"
              rules={[{ required: true, message: "Enter First Name" }]}
            >
              <Input placeholder="First Name" />
            </Form.Item>
            <Form.Item
              className="form-item"
              label={<div className="form-label">Last Name:</div>}
              name="lastName"
              rules={[{ required: true, message: "Enter Last Name" }]}
            >
              <Input placeholder="Last Name" />
            </Form.Item>
            <Form.Item
              className="form-item"
              label={<div className="form-label">Phone Number:</div>}
              name="phoneNumber"
              rules={[
                { required: true, message: "Please enter phone number" },
                ({ getFieldValue }) => ({
                  validator: validatePhoneNumber,
                }),
              ]}
            >
              <Input placeholder="Phone Number" />
            </Form.Item>
            <Form.Item
              className="form-item"
              label={<div className="form-label">Location:</div>}
              name="location"
            >
              <Input placeholder="Location" />
            </Form.Item>
            <Form.Item
              className="form-item"
              label={<div className="form-label">Email ID:</div>}
              name="emailId"
              rules={[
                {
                  required: true,
                  type: "email",
                  message: "Please enter a valid email!",
                },
              ]}
            >
              <Input placeholder="Email ID" />
            </Form.Item>
          </Form>
        </div>
      </div>
      <div className="forms-btns-container">
        <Button className="save-btn" onClick={() => form.submit()}>
          Save
        </Button>
        <Button className="cancel-btn" onClick={() => navigate("/")}>
          Cancel
        </Button>
      </div>
    </div>
  );
}
